import { render, staticRenderFns } from "./MediaTabs.vue?vue&type=template&id=2092fc9c&"
import script from "./MediaTabs.vue?vue&type=script&lang=js&"
export * from "./MediaTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports